import { updatesData } from '@/mocks/comicData';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[720px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {updatesData.title}
        </h2>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>
          <div className="space-y-1">
            {updatesData.items.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4 py-2.5">
                <div className="relative z-10 flex-shrink-0 mt-1">
                  <div
                    className={`w-[10px] h-[10px] rounded-full ${
                      item.type === '公告'
                        ? 'bg-accent-500'
                        : item.type === '上新'
                        ? 'bg-secondary-500'
                        : 'bg-primary-400'
                    }`}
                  ></div>
                </div>
                <div className="flex-1 min-w-0 flex items-baseline gap-3 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                    {item.time}
                  </span>
                  <span className="text-sm text-foreground-700">{item.title}</span>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap flex-shrink-0 font-medium ${
                      item.type === '公告'
                        ? 'bg-accent-100 text-accent-700'
                        : item.type === '上新'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-primary-100 text-primary-700'
                    }`}
                  >
                    {item.type}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}